import { siteConfig } from '@/config/site'
import type { NominationResponsePayload } from '@/nominations/types'

/** POSTs one nomination response to the configured webhook (make.com or similar). */
export const postNominationResponse = async (payload: NominationResponsePayload, webhookUrl: string) => {
  const response = await fetch(webhookUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })

  if (!response.ok) {
    throw new Error(`Nomination webhook responded with ${response.status}`)
  }
}

/**
 * Sends the response to `VITE_NOMINATION_WEBHOOK_URL`.
 * Without a webhook, local development resolves so the success state can be reviewed;
 * production throws so the visitor sees the direct-email fallback instead of a silent drop.
 */
export const submitNominationResponse = async (payload: NominationResponsePayload) => {
  const webhookUrl = siteConfig.nominationWebhookUrl

  if (!webhookUrl) {
    if (import.meta.env.DEV) {
      console.warn('[nominations] VITE_NOMINATION_WEBHOOK_URL is not set. Response was not sent:', payload)
      return
    }

    throw new Error('Nomination webhook is not configured.')
  }

  await postNominationResponse(payload, webhookUrl)
}
